module.exports = __webpack_public_path__ + "img/21.0490be75.png";